import { render, staticRenderFns } from "./AddHostingContactInfo.vue?vue&type=template&id=77f854e8"
import script from "./AddHostingContactInfo.vue?vue&type=script&lang=js"
export * from "./AddHostingContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports